// @core/api/endpoints/tag/bulk_untag_entities.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BulkUntagEntitiesRequest,
} from '../../../types/tag';

const BASE_PATH = '/tag';

/**
 * Bulk untag entities
 * Removes one or more tags from one or more entities in a single operation. Publishes individual untagged events for each removal.
 */
export async function BulkUntagEntities(
  data: BulkUntagEntitiesRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tags/bulk/unassign`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
